module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.show_spinner) ? _c('div', {
    staticClass: "flex justify-center"
  }, [_c('pl-spinner')], 1) : _c('div', {
    staticClass: "grid grid-cols-1 xl:grid-cols-2 gap-x-2.5 gap-y-2.5"
  }, [_c('div', {
    staticClass: "col-span-1 flex flex-col rounded border border-solid border-gray-200"
  }, [_c('div', {
    staticClass: "mb-5 py-3 border-b border-solid border-gray-200 px-4 flex justify-between items-center"
  }, [_c('span', {
    staticClass: "font-semibold text-base text-blueGray-800 font-poppins"
  }, [_vm._v("Participation Rate")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [_c('button', {
    staticClass: "mr-2 text-gray-700 hover:text-gray-800"
  }, [_c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:participation-rate.left",
      arg: "participation-rate",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "fas fa-info-circle"
  })])])]), _vm._v(" "), _c('popover', {
    staticClass: "mr-10 p-0 bg-white drop-shadow absolute z-auto",
    attrs: {
      "name": "participation-rate",
      "width": 420
    }
  }, [_c('div', {
    staticClass: "px-6 py-4 font-semibold border-b"
  }, [_vm._v("Information")]), _vm._v(" "), _c('div', {
    staticClass: "px-6 py-4"
  }, [_vm._v("\n          Students have “participated” when they have at least one turn as\n          speaker during the RoundTable.\n        ")])]), _vm._v(" "), (_vm.participation_rate_data) ? _c('div', {
    staticClass: "relative"
  }, [_c('Chart', {
    attrs: {
      "type": "pie",
      "data": _vm.participation_rate_data,
      "options": _vm.participation_rate_options
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex justify-center"
  }, [_c('span', {
    staticClass: "font-bold",
    style: ({
      color: _vm.color_rate
    })
  }, [_vm._v("\n            " + _vm._s(_vm.rate) + "%\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "ml-1 text-gray-500"
  }, [_vm._v("participated in the discussion")])])], 1) : _c('div', {
    staticClass: "mt-auto mb-auto"
  }, [_c('span', {
    staticClass: "flex justify-center items-center"
  }, [_vm._v("\n          No Data to Display\n        ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-1 h-full flex flex-col rounded border border-solid border-gray-200"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('div', {
    staticClass: "mb-5 py-3 px-4 flex justify-between items-center border-b border-solid border-gray-200"
  }, [_c('span', {
    staticClass: "font-semibold text-base text-blueGray-800 font-poppins"
  }, [_vm._v("Types of Contributions")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [_c('button', {
    staticClass: "mr-2 text-gray-700 hover:text-gray-800"
  }, [_c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:contribution-info.left",
      arg: "contribution-info",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "fas fa-info-circle"
  })]), _vm._v(" "), _c('button', {
    staticClass: "text-gray-700 hover:text-gray-800"
  }, [_c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:contribution-questions.left",
      arg: "contribution-questions",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "fas fa-question-circle"
  })])])]), _vm._v(" "), _c('popover', {
    staticClass: "mr-10 p-0 bg-white drop-shadow absolute z-auto",
    attrs: {
      "name": "contribution-info",
      "width": 600
    }
  }, [_c('div', {
    staticClass: "px-6 py-4 font-semibold border-b"
  }, [_vm._v("Information")]), _vm._v(" "), _c('div', {
    staticClass: "px-6 py-4"
  }, [_vm._v("\n            This chart counts the number of times a student was assigned as\n            speaker for each tap-in type.\n          ")])]), _vm._v(" "), _c('popover', {
    staticClass: "mr-10 p-0 bg-white drop-shadow absolute z-20",
    attrs: {
      "name": "contribution-questions",
      "width": 650
    }
  }, [_c('div', {
    staticClass: "px-4 py-4"
  }, [_c('h5', {
    staticClass: "font-semibold"
  }, [_vm._v("Reflection Questions")])]), _vm._v(" "), _c('div', {
    staticClass: "border-b"
  }), _vm._v(" "), _c('div', {
    staticClass: "px-6 py-4",
    domProps: {
      "innerHTML": _vm._s(_vm.reflections.total_tap_ins)
    }
  })]), _vm._v(" "), (_vm.is_have_contributions) ? _c('div', {
    staticClass: "relative"
  }, [_c('Chart', {
    attrs: {
      "type": "pie",
      "data": _vm.contribution_data,
      "options": _vm.contribution_options,
      "height": 165
    }
  })], 1) : _c('div', {
    staticClass: "flex h-full relative justify-center items-center"
  }, [_vm._m(0)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-1 flex flex-col rounded border border-solid border-gray-200"
  }, [_c('div', {
    staticClass: "mb-5 py-3 px-4 border-b border-solid border-gray-200 flex justify-between items-center"
  }, [_c('h6', {
    staticClass: "font-semibold text-base text-blueGray-800 font-poppins"
  }, [_vm._v("Participation Summary")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [_c('button', {
    staticClass: "mr-2 text-gray-700 hover:text-gray-800"
  }, [_c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:time-spent-info.left",
      arg: "time-spent-info",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "fas fa-info-circle"
  })]), _vm._v(" "), _c('button', {
    staticClass: "text-gray-700 hover:text-gray-800"
  }, [_c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:time-spent-question.left",
      arg: "time-spent-question",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "fas fa-question-circle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "px-7 pt-2 pb-4"
  }, [_c('div', {
    staticClass: "rounded-lg py-1 px-1 bg-trueGray-100 border border-solid border-gray-200",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('ul', {
    staticClass: "flex items-center space-x-1"
  }, [_c('li', [_c('div', {
    staticClass: "flex cursor-pointer items-center space-x-1.5 px-2 rounded-md py-1",
    class: _vm.selectedTabParticipationSummary === 'time-spent' ? 'bg-blueGray-700 text-blueGray-100' : 'text-blueGray-700',
    on: {
      "click": function($event) {
        return _vm.handleChangeTabParticipationSummary('time-spent')
      }
    }
  }, [_c('span', [_vm._v("Time")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "flex cursor-pointer items-center space-x-1.5 px-2 rounded-md py-1",
    class: _vm.selectedTabParticipationSummary === 'tap-in' ? 'bg-blueGray-700 text-blueGray-100' : 'text-blueGray-700',
    on: {
      "click": function($event) {
        return _vm.handleChangeTabParticipationSummary('tap-in')
      }
    }
  }, [_c('span', [_vm._v("Tap In")])])])])]), _vm._v(" "), (_vm.selectedTabParticipationSummary === 'time-spent') ? _c('div', {
    staticClass: "relative mt-5"
  }, [_c('TimeSpentBar', {
    on: {
      "showLabelNoData": function (value) { return (_vm.showLabelNoDataTimeBar = value); }
    }
  })], 1) : _c('div', [(_vm.showLabelNoDataTapIn === false) ? _c('div', {
    staticClass: "flex w-full justify-center items-center h-8"
  }, [_c('TapInCounter'), _vm._v(" "), _c('span', {
    staticClass: "ml-1 text-gray-500"
  }, [_vm._v("\n              Average speaking turns per student\n            ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('TapInSummaryBar', {
    on: {
      "showLabelNoData": function (value) { return (_vm.showLabelNoDataTapIn = value); }
    }
  })], 1), _vm._v(" "), (_vm.showLabelNoDataTapIn === true || _vm.showLabelNoDataTimeBar === true) ? _c('div', [_vm._m(1)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-1 flex flex-col h-full rounded border border-solid border-gray-200"
  }, [_c('div', {
    staticClass: "relative h-full"
  }, [_c('div', {
    staticClass: "mb-5 flex justify-between items-center py-3 px-4 border-b border-solid border-gray-200"
  }, [_c('span', {
    staticClass: "font-semibold text-base text-blueGray-800 font-poppins"
  }, [_vm._v("Chord Diagram")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [_c('button', {
    staticClass: "mr-2 text-gray-700 hover:text-gray-800"
  }, [_c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:contribution-info.left",
      arg: "contribution-info",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "fas fa-info-circle"
  })]), _vm._v(" "), _c('button', {
    staticClass: "text-gray-700 hover:text-gray-800"
  }, [_c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:contribution-questions.left",
      arg: "contribution-questions",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "fas fa-question-circle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-center h-full -mt-12 py-3 px-6"
  }, [_c('ChordDiagramverbal')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-1 flex flex-col h-full rounded border border-solid border-gray-200"
  }, [_c('div', {
    staticClass: "relative h-full"
  }, [_c('div', {
    staticClass: "mb-5 flex justify-between items-center border-b border-solid border-gray-200 py-2 px-4"
  }, [_c('span', {
    staticClass: "font-semibold text-base text-blueGray-800 font-poppins"
  }, [_vm._v("Word Cloud")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-1"
  }, [_c('button', {
    staticClass: "bg-white border border-solid border-gray-200 text-sm hover:bg-gray-100 rounded px-3 py-1",
    attrs: {
      "title": "Refresh"
    },
    on: {
      "click": function($event) {
        return _vm.handleRefreshWordCloud()
      }
    }
  }, [(_vm.isRefreshingCloud === true) ? _c('i', {
    staticClass: "animate-spin fa-solid fa-arrows-rotate"
  }) : _vm._e(), _vm._v(" "), (_vm.isRefreshingCloud === false) ? _c('i', {
    staticClass: "fa-solid fa-arrows-rotate"
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "bg-white border border-solid border-gray-200 text-sm hover:bg-gray-100 rounded px-3 py-1 flex items-center space-x-1.5",
    attrs: {
      "title": "Change Word Cloud"
    },
    on: {
      "click": function($event) {
        return _vm.handleOpenEditWordCloud()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-pen-to-square"
  }), _vm._v(" "), _c('span', [_vm._v("Edit Words")])])])]), _vm._v(" "), (_vm.isWordCloudLoading === false) ? _c('div', {
    staticClass: "flex items-center justify-center h-full px-5 py-5 -mt-12"
  }, [_c('VueWordCloud', {
    staticStyle: {
      "width": "100%",
      "height": "500px",
      "margin": "0"
    },
    attrs: {
      "spacing": 0.2,
      "words": _vm.wordCloudData,
      "color": function (ref) {
        var sent = ref[2];

        return sent === 'blu' ? '#72CCD7' : sent === 'red' ? '#EB2D7C' : '#273248';
  },
      "font-family": "Poppins",
      "font-weight": "Bold"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var text = ref.text;
        var weight = ref.weight;

        return [_c('div', {
          staticClass: "cursor-pointer",
          attrs: {
            "title": weight
          }
        }, [_vm._v("\n                " + _vm._s(text) + "\n              ")])]
      }
    }], null, false, 2114301377)
  })], 1) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center py-28"
  }, [_c('span', [_vm._v("No data to display")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center py-28"
  }, [_c('span', [_vm._v("No data to display")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-28c495c3!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/tabs/LDSummaryTab.vue
// module id = 1799
// module chunks = 61